import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { smoothScrollTo } from './utils/smoothScroll';
import { openWhatsAppChat } from './WhatsAppFloat';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleFooterLink = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    if (href.startsWith('#')) {
      if (location.pathname === '/') {
        smoothScrollTo(href.substring(1));
      } else {
        navigate('/');
        setTimeout(() => smoothScrollTo(href.substring(1)), 300);
      }
    } else {
      navigate(href);
    }
  };

  return (
    <>
      <style>{`
        .footer {
          padding: 120px 48px 60px;
          text-align: center;
          border-top: 1px solid var(--border, rgba(255, 255, 255, 0.08));
          /* Footer menggunakan tema dark sendiri */
          --bg: #0a1628;
          --text: #ffffff;
          --muted: rgba(255, 255, 255, 0.7);
          --muted-2: rgba(255, 255, 255, 0.6);
          --border: rgba(255, 255, 255, 0.08);
          --border-strong: rgba(255, 255, 255, 0.12);
          --card: rgba(255, 255, 255, 0.03);
          --card-2: rgba(255, 255, 255, 0.02);
          --chip: rgba(255, 255, 255, 0.08);
          --accent: #ffffff;
          --accent-contrast: #0a1628;
          background: var(--bg);
          color: var(--text);
        }

        .footer-title {
          font-size: clamp(36px, 6vw, 80px);
          font-weight: 700;
          letter-spacing: -0.03em;
          margin-bottom: 48px;
          line-height: 1.1;
          color: var(--text, #ffffff);
        }

        .footer-links {
          display: flex;
          justify-content: center;
          gap: 40px;
          margin-top: 60px;
          padding-top: 40px;
          border-top: 1px solid var(--border, rgba(255, 255, 255, 0.08));
        }

        .footer-links a {
          color: var(--muted-2, rgba(255, 255, 255, 0.6));
          text-decoration: none;
          font-size: 14px;
          transition: color 0.3s;
        }

        .footer-links a:hover {
          color: var(--text, #ffffff);
        }

        .cta-button {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          background: var(--accent, #ffffff);
          color: var(--accent-contrast, #0f0f0f);
          padding: 18px 36px;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 600;
          font-size: 16px;
          transition: all 0.3s;
          border: 2px solid var(--accent, #ffffff);
        }

        .cta-button:hover {
          background: transparent;
          color: var(--accent, #ffffff);
          border-color: var(--accent, #ffffff);
          transform: scale(1.05);
        }

        .footer-info {
          margin-top: 40px;
          color: var(--muted, rgba(255, 255, 255, 0.7));
          font-size: 16px;
        }

        .footer-copyright {
          margin-top: 20px;
          color: var(--muted-2, rgba(255, 255, 255, 0.5));
          font-size: 14px;
        }

        @media (max-width: 768px) {
          .footer {
            padding: 80px 24px;
          }

          .footer-links {
            flex-direction: column;
            gap: 20px;
          }
        }
      `}</style>
      <footer className="footer">
        <h2 className="footer-title">Siap Memulai Transformasi Digital?</h2>
        <button
          type="button"
          className="cta-button"
          onClick={openWhatsAppChat}
        >
          Hubungi Kami
        </button>

        <div className="footer-links">
          <a href="#tentang" onClick={(e) => handleFooterLink(e, '#tentang')}>Tentang</a>
          <a href="#produk" onClick={(e) => handleFooterLink(e, '#produk')}>Produk</a>
          <a href="#layanan" onClick={(e) => handleFooterLink(e, '#layanan')}>Layanan</a>
          <a href="#fitur" onClick={(e) => handleFooterLink(e, '#fitur')}>Fitur</a>
          <a href="#team" onClick={(e) => handleFooterLink(e, '#team')}>Tim</a>
        </div>
        <div className="footer-info">
          PT. Tri Cipta Integra · triciptaintegra.com · info@triciptaintegra.com
        </div>
        <div className="footer-copyright">
          Copyright © 2025 PT. Tri Cipta Integra
        </div>
      </footer>
    </>
  );
};

export default Footer;

